import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projects-style-three',
  templateUrl: './projects-style-three.component.html',
  styleUrls: ['./projects-style-three.component.scss']
})
export class ProjectsStyleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
